
    function deshorten(arrOfArr) {
      var headers = arrOfArr.headers;
      var data = arrOfArr.data;
      return data.map(function (d) {
        var o = {};
        headers.forEach(function (h, i) {
          o[h] = d[i];
        })
        return o;
      });
    }

    var str = '{"headers":["sector","emission_mmt_co2","emission_percentage"],"data":[["agriculture",8802.04,18.59],["buildings",3548.47,7.49],["electricity",13236.1,27.95],["manufacturing",14606.53,30.84],["transportation",7164.1,15.13],["LULUCF",640.16,1.35]]}';
    var shortenedJson = JSON.parse(str);
    module.exports = deshorten(shortenedJson);
  